// Rodape institucional do catalogo publico — Onda Catalogo Fase 3.
// Compacto: sem titulo/tagline (o cabecalho ja exibe a marca). So contato,
// identificacao legal e link da politica de privacidade.
// Usado por CatalogoPublicoLista, CatalogoPublicoProduto e CatalogoPublicoPrivacidade.
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useContatoCatalogo } from './useContatoCatalogo';

const ANO = new Date().getFullYear();

export function RodapeCatalogo() {
  // Hook (e nao <LinksWhatsapp/>) porque aqui o icone tambem some junto quando
  // nao ha numero — icone de telefone sozinho fica sem sentido.
  const contatos = useContatoCatalogo();

  return (
    <footer style={{ backgroundColor: '#262626', color: '#d4d4d4' }} className="mt-8">
      <div className="max-w-5xl mx-auto px-4 py-4 text-xs">
        {/* Contato */}
        <div className="flex items-start gap-2 leading-snug">
          <MapPin size={14} className="mt-0.5 flex-shrink-0" style={{ color: '#f59e0b' }} />
          <span>
            Av. Rio da Prata, 920 — Setor Montes Belos, Sao Luis de Montes Belos / GO —
            CEP 76052-201
          </span>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1.5">
          {contatos.map((c) => (
            <a
              key={c.numero}
              href={c.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5"
              style={{ color: '#d4d4d4', textDecoration: 'none' }}
            >
              <Phone size={14} className="flex-shrink-0" style={{ color: '#f59e0b' }} />
              {c.display}
            </a>
          ))}
          <a
            href="mailto:atendimento@fiodecobre.com.br"
            className="flex items-center gap-1.5"
            style={{ color: '#d4d4d4', textDecoration: 'none' }}
          >
            <Mail size={14} className="flex-shrink-0" style={{ color: '#f59e0b' }} />
            atendimento@fiodecobre.com.br
          </a>
        </div>

        {/* Segmentos (landing pages locais — Estrategia Google Fase 3).
            <a href> e nao <Link>: sao paginas servidas pelo backend, fora da SPA. */}
        <div
          className="mt-3 pt-3 flex flex-wrap items-center gap-x-3 gap-y-1"
          style={{ borderTop: '1px solid #404040' }}
        >
          <a href="/materiais-eletricos" style={{ color: '#f59e0b' }} className="font-medium">
            Materiais Eletricos
          </a>
          <a href="/ar-condicionado" style={{ color: '#f59e0b' }} className="font-medium">
            Ar Condicionado
          </a>
          <a href="/piscina" style={{ color: '#f59e0b' }} className="font-medium">
            Piscina
          </a>
        </div>

        {/* Identificacao legal + politica */}
        <div
          className="mt-3 pt-3 flex flex-wrap items-center gap-x-3 gap-y-1"
          style={{ borderTop: '1px solid #404040' }}
        >
          <span className="opacity-70">FIO DE COBRE LTDA · CNPJ 49.762.154/0001-00</span>
          <Link to="/a-loja" style={{ color: '#f59e0b' }} className="font-medium">
            A Loja
          </Link>
          <Link to="/trocas-e-devolucoes" style={{ color: '#f59e0b' }} className="font-medium">
            Trocas e Devolucoes
          </Link>
          <Link to="/termos" style={{ color: '#f59e0b' }} className="font-medium">
            Termos
          </Link>
          <Link to="/privacidade" style={{ color: '#f59e0b' }} className="font-medium">
            Privacidade
          </Link>
        </div>
        <p className="mt-2 opacity-50">
          Precos e imagens sujeitos a alteracao. &copy; {ANO} Fio de Cobre.
        </p>
      </div>
    </footer>
  );
}
